import IMask from 'imask';

document.addEventListener('DOMContentLoaded', () => {
    const phoneElement = document.getElementById('phone');

    if (!phoneElement) return;

    const mask = IMask(phoneElement, {
        mask: '+{7} (000) 000-00-00',
        lazy: false,
        blocks: {},
        prepare: (str) => str,
    });

    phoneElement.addEventListener('keydown', (event) => {
        const pos = phoneElement.selectionStart;

        if (
            (event.key === 'Backspace' && pos <= 4) ||
            (event.key === 'Delete' && pos < 4) ||
            (['ArrowLeft', 'Home'].includes(event.key) && pos <= 4)
        ) {
            event.preventDefault();
            phoneElement.setSelectionRange(4, 4);
        }
    });

    phoneElement.addEventListener('paste', (event) => {
        event.preventDefault();

        let pastedText = (event.clipboardData || window.clipboardData).getData('text');
        let digits = pastedText.replace(/\D/g, '');

        if (digits.length === 11 && digits.startsWith('8')) {
            digits = '7' + digits.slice(1);
        }

        if (digits.length === 10) {
            digits = '7' + digits;
        }

        if (digits.length !== 11 || !digits.startsWith('7')) return;

        mask.value = '+' + digits;

        phoneElement.dispatchEvent(new Event('input', { bubbles: true }));
    });
});
